import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3" };
const _hoisted_3 = { class: "text-sm font-medium text-eorange-600" };
const _hoisted_4 = { class: "text-2xl font-semibold text-eblack-900" };
const _hoisted_5 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_6 = { class: "flex flex-wrap items-center gap-2" };
const _hoisted_7 = ["disabled"];
const _hoisted_8 = { class: "grid gap-3 md:grid-cols-2 xl:grid-cols-4" };
const _hoisted_9 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_10 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_11 = {
    key: 0,
    class: "flex flex-wrap items-center justify-between gap-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
    "data-test": "payments-error"
};
const _hoisted_12 = { class: "flex flex-wrap gap-2 border-b border-ewhite-200" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = { class: "rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_15 = { class: "grid gap-3 border-b border-ewhite-100 p-4 md:grid-cols-[minmax(180px,1fr)_180px_auto]" };
const _hoisted_16 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_17 = ["placeholder"];
const _hoisted_18 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_19 = { value: "" };
const _hoisted_20 = ["value"];
const _hoisted_21 = { class: "flex items-end gap-2" };
const _hoisted_22 = {
    key: 0,
    class: "flex flex-wrap items-center justify-between gap-3 border-b border-ewhite-100 p-4"
};
const _hoisted_23 = { class: "text-sm text-eblack-600" };
const _hoisted_24 = ["disabled"];
const _hoisted_25 = { class: "overflow-x-auto" };
const _hoisted_26 = { class: "min-w-[980px] w-full divide-y divide-ewhite-100 text-left text-sm" };
const _hoisted_27 = { class: "bg-ewhite-50 text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_28 = {
    key: 0,
    class: "px-4 py-3"
};
const _hoisted_29 = { class: "px-4 py-3" };
const _hoisted_30 = { class: "px-4 py-3" };
const _hoisted_31 = { class: "px-4 py-3" };
const _hoisted_32 = { class: "px-4 py-3" };
const _hoisted_33 = { class: "px-4 py-3" };
const _hoisted_34 = { class: "px-4 py-3" };
const _hoisted_35 = { class: "divide-y divide-ewhite-100 bg-white" };
const _hoisted_36 = { key: 0 };
const _hoisted_37 = ["colspan"];
const _hoisted_38 = { key: 1 };
const _hoisted_39 = ["colspan"];
const _hoisted_40 = {
    key: 0,
    class: "px-4 py-3"
};
const _hoisted_41 = ["checked", "disabled", "onChange"];
const _hoisted_42 = { class: "px-4 py-3 align-top" };
const _hoisted_43 = { class: "font-semibold text-eblack-900" };
const _hoisted_44 = { class: "text-xs text-eblack-500" };
const _hoisted_45 = { class: "px-4 py-3 align-top text-eblack-700" };
const _hoisted_46 = { class: "px-4 py-3 align-top" };
const _hoisted_47 = { class: "px-4 py-3 align-top font-medium text-eblack-900" };
const _hoisted_48 = { class: "px-4 py-3 align-top text-eblack-600" };
const _hoisted_49 = { class: "px-4 py-3 align-top" };
const _hoisted_50 = { class: "flex flex-wrap gap-2" };
const _hoisted_51 = ["onClick"];
const _hoisted_52 = ["onClick"];
const _hoisted_53 = ["onClick"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = {
    key: 4,
    class: "text-xs text-eblack-400"
};
const _hoisted_56 = {
    key: 1,
    class: "fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4",
    "data-test": "payments-action-modal"
};
const _hoisted_57 = { class: "w-full max-w-xl rounded-lg bg-white p-5 shadow-xl" };
const _hoisted_58 = { class: "flex items-start justify-between gap-3" };
const _hoisted_59 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_60 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_61 = ["aria-label"];
const _hoisted_62 = { class: "mt-4 grid gap-3" };
const _hoisted_63 = {
    key: 0,
    class: "flex flex-col gap-1 text-sm font-medium text-eblack-700"
};
const _hoisted_64 = {
    key: 1,
    class: "flex flex-col gap-1 text-sm font-medium text-eblack-700"
};
const _hoisted_65 = {
    key: 2,
    class: "flex flex-col gap-1 text-sm font-medium text-eblack-700"
};
const _hoisted_66 = { value: "submitted" };
const _hoisted_67 = { value: "paid" };
const _hoisted_68 = { value: "failed" };
const _hoisted_69 = { value: "cancelled" };
const _hoisted_70 = {
    key: 3,
    class: "flex flex-col gap-1 text-sm font-medium text-eblack-700"
};
const _hoisted_71 = { value: "matched" };
const _hoisted_72 = { value: "ignored" };
const _hoisted_73 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_74 = ["placeholder"];
const _hoisted_75 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_76 = ["placeholder"];
const _hoisted_77 = {
    key: 4,
    class: "flex flex-col gap-1 text-sm font-medium text-eblack-700"
};
const _hoisted_78 = { class: "mt-5 flex flex-wrap justify-end gap-2" };
const _hoisted_79 = ["disabled"];
import { computed, onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { IconCash, IconRefresh, IconX, } from "@tabler/icons-vue";
import { usePaymentOperationsStore } from "@/domains/payments";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GlobalPaymentsIndex',
    setup(__props) {
        const { t } = useI18n();
        const store = usePaymentOperationsStore();
        const activeTab = ref("requests");
        const selectedPayableIds = ref([]);
        const filters = reactive({
            search: "",
            status: "",
        });
        const actionModal = ref(null);
        const copiedPaymentRequestId = ref(null);
        const actionForm = reactive({
            amount_minor: 0,
            currency: "USD",
            status: "submitted",
            reason: "",
            evidence_url: "",
            idempotency_key: "",
        });
        const tabs = computed(() => [
            { key: "requests", label: t("settings.billing.payments.tabs.requests") },
            { key: "reconciliation", label: t("settings.billing.payments.tabs.reconciliation") },
            { key: "refunds", label: t("settings.billing.payments.tabs.refunds") },
            { key: "payables", label: t("settings.billing.payments.tabs.payables") },
            { key: "payouts", label: t("settings.billing.payments.tabs.payouts") },
            { key: "events", label: t("settings.billing.payments.tabs.events") },
        ]);
        const statusOptions = computed(() => {
            const map = {
                requests: [
                    "checkout_created",
                    "processing",
                    "succeeded",
                    "failed",
                    "cancelled",
                    "expired",
                ],
                reconciliation: ["matched", "mismatch", "unmatched", "ignored"],
                refunds: ["requested", "processing", "succeeded", "failed", "cancelled"],
                payables: ["held", "ready", "payout_pending", "released", "void"],
                payouts: ["draft", "submitted", "paid", "failed", "cancelled"],
                events: ["processed", "pending", "failed"],
            };
            return map[activeTab.value];
        });
        const rows = computed(() => {
            if (activeTab.value === "requests")
                return store.requests.items;
            if (activeTab.value === "reconciliation")
                return store.reconciliation.items;
            if (activeTab.value === "refunds")
                return store.refunds.items;
            if (activeTab.value === "payables")
                return store.payables.items;
            if (activeTab.value === "payouts")
                return store.payoutBatches.items;
            return store.onvoEvents.items;
        });
        const summaryCards = computed(() => {
            const summary = store.dashboard?.summary;
            return [
                {
                    key: "open_requests",
                    label: t("settings.billing.payments.cards.open_requests"),
                    value: String(summary?.open_requests ?? 0),
                },
                {
                    key: "collected",
                    label: t("settings.billing.payments.cards.collected"),
                    value: money(summary?.collected_minor ?? 0, "USD"),
                },
                {
                    key: "open_reconciliation",
                    label: t("settings.billing.payments.cards.reconciliation"),
                    value: String(summary?.open_reconciliation ?? 0),
                },
                {
                    key: "open_payouts",
                    label: t("settings.billing.payments.cards.payouts"),
                    value: String(summary?.open_payout_batches ?? 0),
                },
            ];
        });
        const actionTitle = computed(() => {
            if (!actionModal.value)
                return "";
            return t(`settings.billing.payments.modal.${actionModal.value.type}.title`);
        });
        const actionDescription = computed(() => {
            if (!actionModal.value)
                return "";
            return t(`settings.billing.payments.modal.${actionModal.value.type}.description`);
        });
        const canSubmitAction = computed(() => {
            if (!actionModal.value)
                return false;
            if (!actionForm.reason || !actionForm.evidence_url)
                return false;
            if (actionModal.value.type === "refund") {
                return actionForm.amount_minor > 0 && !!actionForm.idempotency_key;
            }
            if (actionModal.value.type === "payout_create") {
                return selectedPayableIds.value.length > 0 && !!actionForm.idempotency_key;
            }
            return true;
        });
        onMounted(refreshAll);
        async function refreshAll() {
            await Promise.all([
                store.fetchPlatformDashboard(),
                loadActiveTab(),
            ]);
        }
        async function loadActiveTab() {
            const query = {
                search: filters.search || undefined,
                status: filters.status || undefined,
            };
            if (activeTab.value === "requests")
                await store.fetchPlatformRequests(query);
            if (activeTab.value === "reconciliation") {
                await store.fetchPlatformReconciliation(query);
            }
            if (activeTab.value === "refunds")
                await store.fetchPlatformRefunds(query);
            if (activeTab.value === "payables")
                await store.fetchPlatformPayables(query);
            if (activeTab.value === "payouts") {
                await store.fetchPlatformPayoutBatches(query);
            }
            if (activeTab.value === "events")
                await store.fetchPlatformOnvoEvents(query);
        }
        function selectTab(tab) {
            activeTab.value = tab;
            selectedPayableIds.value = [];
            filters.status = "";
            loadActiveTab();
        }
        function clearFilters() {
            filters.search = "";
            filters.status = "";
            loadActiveTab();
        }
        function openRefund(row) {
            resetActionForm();
            actionForm.amount_minor = row.amount_minor;
            actionForm.currency = row.currency;
            actionModal.value = { type: "refund", row };
        }
        function openPayoutCreate() {
            resetActionForm();
            actionModal.value = { type: "payout_create" };
        }
        function openPayoutStatus(row) {
            resetActionForm();
            actionForm.status = row.status === "draft" ? "submitted" : "paid";
            actionModal.value = { type: "payout_status", row };
        }
        function openResolve(row) {
            resetActionForm();
            actionForm.status = "matched";
            actionModal.value = { type: "reconciliation", row };
        }
        function closeAction() {
            actionModal.value = null;
            resetActionForm();
        }
        async function submitAction() {
            if (!actionModal.value || !canSubmitAction.value)
                return;
            if (actionModal.value.type === "refund") {
                await store.requestRefund(actionModal.value.row.id, {
                    amount_minor: actionForm.amount_minor,
                    currency: actionForm.currency,
                    reason: actionForm.reason,
                    evidence_url: actionForm.evidence_url,
                }, actionForm.idempotency_key);
            }
            if (actionModal.value.type === "payout_create") {
                await store.createPayoutBatch({
                    payable_ids: [...selectedPayableIds.value],
                    reason: actionForm.reason,
                    evidence_url: actionForm.evidence_url,
                }, actionForm.idempotency_key);
                selectedPayableIds.value = [];
            }
            if (actionModal.value.type === "payout_status") {
                await store.updatePayoutBatch(actionModal.value.row.id, {
                    status: actionForm.status,
                    reason: actionForm.reason,
                    evidence_url: actionForm.evidence_url,
                });
            }
            if (actionModal.value.type === "reconciliation") {
                await store.resolveReconciliation(actionModal.value.row.id, {
                    status: actionForm.status,
                    reason: actionForm.reason,
                    evidence_url: actionForm.evidence_url,
                });
            }
            closeAction();
        }
        function resetActionForm() {
            actionForm.amount_minor = 0;
            actionForm.currency = "USD";
            actionForm.status = "submitted";
            actionForm.reason = "";
            actionForm.evidence_url = "";
            actionForm.idempotency_key = "";
        }
        function togglePayable(id) {
            selectedPayableIds.value = selectedPayableIds.value.includes(id)
                ? selectedPayableIds.value.filter((item) => item !== id)
                : [...selectedPayableIds.value, id];
        }
        function isSelectablePayable(row) {
            return ["held", "ready"].includes(row.status);
        }
        function hasRowAction(row) {
            if (canCopyCheckoutUrl(row))
                return true;
            if (activeTab.value === "requests")
                return row.status === "succeeded";
            if (activeTab.value === "reconciliation") {
                return ["mismatch", "unmatched"].includes(row.status);
            }
            if (activeTab.value === "payouts") {
                return ["draft", "submitted"].includes(row.status);
            }
            return false;
        }
        function canCopyCheckoutUrl(row) {
            return (activeTab.value === "requests" &&
                row.status === "checkout_created" &&
                typeof row.checkout_url === "string" &&
                row.checkout_url.length > 0);
        }
        async function copyCheckoutUrl(row) {
            await navigator.clipboard.writeText(row.checkout_url);
            copiedPaymentRequestId.value = row.id;
        }
        function recordMeta(row) {
            if (activeTab.value === "requests") {
                return `${t("settings.billing.payments.table.itinerary")} #${row.itinerary_id}`;
            }
            if (activeTab.value === "payables") {
                return `${t("settings.billing.payments.table.booking")} #${row.booking_id ?? "-"}`;
            }
            if (activeTab.value === "events")
                return row.event_type;
            if (row.payment_request_id) {
                return `${t("settings.billing.payments.table.payment")} #${row.payment_request_id}`;
            }
            return "-";
        }
        function contextLabel(row) {
            if (row.organization?.display_name)
                return row.organization.display_name;
            if (row.provider?.display_name)
                return row.provider.display_name;
            if (row.concierge?.display_name)
                return row.concierge.display_name;
            if (row.provider_event_id)
                return row.provider_event_id;
            return "-";
        }
        function amountLabel(row) {
            if (typeof row.amount_minor === "number") {
                return money(row.amount_minor, row.currency || "USD");
            }
            if (typeof row.expected_amount_minor === "number") {
                return `${money(row.expected_amount_minor, row.currency || "USD")} / ${money(row.provider_amount_minor ?? 0, row.currency || "USD")}`;
            }
            return "-";
        }
        function money(amountMinor, currency) {
            return new Intl.NumberFormat(undefined, {
                style: "currency",
                currency: currency || "USD",
            }).format((amountMinor || 0) / 100);
        }
        function dateLabel(value) {
            if (!value)
                return "-";
            return new Intl.DateTimeFormat(undefined, {
                dateStyle: "medium",
                timeStyle: "short",
            }).format(new Date(value));
        }
        function statusLabel(status) {
            return t(`settings.billing.payments.status.${status}`, status);
        }
        function statusClass(status) {
            if (["succeeded", "paid", "released", "matched", "processed"].includes(status)) {
                return "bg-green-50 text-green-700";
            }
            if (["failed", "mismatch", "unmatched", "cancelled", "expired"].includes(status)) {
                return "bg-red-50 text-red-700";
            }
            if (["processing", "payout_pending", "submitted", "requested"].includes(status)) {
                return "bg-blue-50 text-blue-700";
            }
            return "bg-ewhite-100 text-eblack-700";
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("settings.billing.payments.global.eyebrow")), 1),
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("settings.billing.payments.global.title")), 1),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("settings.billing.payments.global.description")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_router_link, {
                            to: "/admin/global/billing",
                            class: "inline-flex h-9 items-center rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.tabs.subscriptions")), 1)
                            ]),
                            _: 1
                        }),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex h-9 items-center gap-2 rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                            disabled: _unref(store).isLoading,
                            "data-test": "payments-refresh",
                            onClick: refreshAll
                        }, [
                            _createVNode(_unref(IconRefresh), { class: "h-4 w-4" }),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.refresh")), 1)
                        ], 8, _hoisted_7)
                    ])
                ]),
                _createElementVNode("section", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryCards.value, (card) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: card.key,
                            class: "rounded-lg border border-ewhite-200 bg-white p-4"
                        }, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(card.label), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(card.value), 1)
                        ]));
                    }), 128))
                ]),
                (_unref(store).error)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(_unref(store).error), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-red-200 px-2.5 py-1 font-medium hover:bg-red-100",
                            onClick: refreshAll
                        }, _toDisplayString(_unref(t)("settings.billing.actions.retry")), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                        return (_openBlock(), _createElementBlock("button", {
                            key: tab.key,
                            type: "button",
                            class: _normalizeClass(["border-b-2 px-3 py-2 text-sm font-semibold transition-colors",
                                activeTab.value === tab.key
                                    ? 'border-eorange-500 text-eblack-900'
                                    : 'border-transparent text-eblack-500 hover:text-eblack-800'
                            ]),
                            "data-test": "payments-tab",
                            onClick: ($event) => (selectTab(tab.key))
                        }, _toDisplayString(tab.label), 11, _hoisted_13));
                    }), 128))
                ]),
                _createElementVNode("section", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, [
                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.filters.search")) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.search) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                "data-test": "payments-search",
                                placeholder: _unref(t)('settings.billing.payments.filters.search_placeholder'),
                                onKeydown: _withKeys(loadActiveTab, ["enter"])
                            }, null, 40, _hoisted_17), [
                                [
                                    _vModelText,
                                    filters.search,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_18, [
                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.filters.status")) + " ", 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filters.status) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                "data-test": "payments-status-filter",
                                onChange: loadActiveTab
                            }, [
                                _createElementVNode("option", _hoisted_19, _toDisplayString(_unref(t)("settings.billing.payments.filters.any_status")), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusOptions.value, (status) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: status,
                                        value: status
                                    }, _toDisplayString(statusLabel(status)), 9, _hoisted_20));
                                }), 128))
                            ], 544), [
                                [_vModelSelect, filters.status]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50",
                                "data-test": "payments-apply",
                                onClick: loadActiveTab
                            }, _toDisplayString(_unref(t)("settings.billing.actions.apply")), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg px-3 text-sm font-medium text-eblack-500 hover:bg-ewhite-50",
                                "data-test": "payments-clear",
                                onClick: clearFilters
                            }, _toDisplayString(_unref(t)("settings.billing.actions.clear")), 1)
                        ])
                    ]),
                    (activeTab.value === 'payables')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)("settings.billing.payments.selected_payables", { count: selectedPayableIds.value.length })), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex h-9 items-center gap-2 rounded-lg bg-eblack-900 px-3 text-sm font-semibold text-white hover:bg-eblack-800 disabled:opacity-50",
                                disabled: selectedPayableIds.value.length === 0,
                                "data-test": "payments-create-payout",
                                onClick: openPayoutCreate
                            }, [
                                _createVNode(_unref(IconCash), { class: "h-4 w-4" }),
                                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.payments.actions.create_payout")), 1)
                            ], 8, _hoisted_24)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("table", _hoisted_26, [
                            _createElementVNode("thead", _hoisted_27, [
                                _createElementVNode("tr", null, [
                                    (activeTab.value === 'payables')
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_28, _toDisplayString(_unref(t)("settings.billing.payments.table.select")), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("th", _hoisted_29, _toDisplayString(_unref(t)("settings.billing.payments.table.record")), 1),
                                    _createElementVNode("th", _hoisted_30, _toDisplayString(_unref(t)("settings.billing.payments.table.context")), 1),
                                    _createElementVNode("th", _hoisted_31, _toDisplayString(_unref(t)("settings.billing.payments.table.status")), 1),
                                    _createElementVNode("th", _hoisted_32, _toDisplayString(_unref(t)("settings.billing.payments.table.amount")), 1),
                                    _createElementVNode("th", _hoisted_33, _toDisplayString(_unref(t)("settings.billing.payments.table.updated")), 1),
                                    _createElementVNode("th", _hoisted_34, _toDisplayString(_unref(t)("settings.billing.payments.table.actions")), 1)
                                ])
                            ]),
                            _createElementVNode("tbody", _hoisted_35, [
                                (_unref(store).isLoading)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                                        _createElementVNode("td", {
                                            colspan: activeTab.value === 'payables' ? 7 : 6,
                                            class: "px-4 py-8 text-center text-eblack-500"
                                        }, _toDisplayString(_unref(t)("settings.billing.payments.loading")), 9, _hoisted_37)
                                    ]))
                                    : (rows.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                                            _createElementVNode("td", {
                                                colspan: activeTab.value === 'payables' ? 7 : 6,
                                                class: "px-4 py-8 text-center text-eblack-500"
                                            }, _toDisplayString(_unref(t)("settings.billing.payments.empty")), 9, _hoisted_39)
                                        ]))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(rows.value, (row) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: row.id
                                            }, [
                                                (activeTab.value === 'payables')
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                                                        _createElementVNode("input", {
                                                            checked: selectedPayableIds.value.includes(row.id),
                                                            disabled: !isSelectablePayable(row),
                                                            type: "checkbox",
                                                            class: "h-4 w-4 rounded border-ewhite-300",
                                                            "data-test": "payable-select",
                                                            onChange: ($event) => (togglePayable(row.id))
                                                        }, null, 40, _hoisted_41)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("td", _hoisted_42, [
                                                    _createElementVNode("p", _hoisted_43, "#" + _toDisplayString(row.id), 1),
                                                    _createElementVNode("p", _hoisted_44, _toDisplayString(recordMeta(row)), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_45, _toDisplayString(contextLabel(row)), 1),
                                                _createElementVNode("td", _hoisted_46, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["inline-flex rounded-full px-2 py-0.5 text-xs font-semibold", statusClass(row.status)])
                                                    }, _toDisplayString(statusLabel(row.status)), 3)
                                                ]),
                                                _createElementVNode("td", _hoisted_47, _toDisplayString(amountLabel(row)), 1),
                                                _createElementVNode("td", _hoisted_48, _toDisplayString(dateLabel(row.updated_at || row.received_at || row.timeline?.updated_at)), 1),
                                                _createElementVNode("td", _hoisted_49, [
                                                    _createElementVNode("div", _hoisted_50, [
                                                        (canCopyCheckoutUrl(row))
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                type: "button",
                                                                class: "rounded-lg border border-ewhite-200 px-2.5 py-1 text-xs font-semibold text-eblack-700 hover:bg-ewhite-50",
                                                                "data-test": "payments-copy-checkout-url",
                                                                onClick: ($event) => (copyCheckoutUrl(row))
                                                            }, _toDisplayString(copiedPaymentRequestId.value === row.id
                                                                ? _unref(t)("settings.billing.payments.actions.copied")
                                                                : _unref(t)("settings.billing.payments.actions.copy_link")), 9, _hoisted_51))
                                                            : _createCommentVNode("", true),
                                                        (activeTab.value === 'requests' && row.status === 'succeeded')
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 1,
                                                                type: "button",
                                                                class: "rounded-lg border border-ewhite-200 px-2.5 py-1 text-xs font-semibold text-eblack-700 hover:bg-ewhite-50",
                                                                "data-test": "payments-refund-action",
                                                                onClick: ($event) => (openRefund(row))
                                                            }, _toDisplayString(_unref(t)("settings.billing.payments.actions.refund")), 9, _hoisted_52))
                                                            : _createCommentVNode("", true),
                                                        (activeTab.value === 'reconciliation' && ['mismatch', 'unmatched'].includes(row.status))
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 2,
                                                                type: "button",
                                                                class: "rounded-lg border border-ewhite-200 px-2.5 py-1 text-xs font-semibold text-eblack-700 hover:bg-ewhite-50",
                                                                "data-test": "payments-resolve-action",
                                                                onClick: ($event) => (openResolve(row))
                                                            }, _toDisplayString(_unref(t)("settings.billing.payments.actions.resolve")), 9, _hoisted_53))
                                                            : _createCommentVNode("", true),
                                                        (activeTab.value === 'payouts' && ['draft', 'submitted'].includes(row.status))
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 3,
                                                                type: "button",
                                                                class: "rounded-lg border border-ewhite-200 px-2.5 py-1 text-xs font-semibold text-eblack-700 hover:bg-ewhite-50",
                                                                "data-test": "payments-payout-status-action",
                                                                onClick: ($event) => (openPayoutStatus(row))
                                                            }, _toDisplayString(_unref(t)("settings.billing.payments.actions.update")), 9, _hoisted_54))
                                                            : _createCommentVNode("", true),
                                                        (!hasRowAction(row))
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_unref(t)("settings.billing.payments.actions.none")), 1))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ])
                                            ]));
                                        }), 128))
                            ])
                        ])
                    ])
                ]),
                (actionModal.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _createElementVNode("section", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("h2", _hoisted_59, _toDisplayString(actionTitle.value), 1),
                                    _createElementVNode("p", _hoisted_60, _toDisplayString(actionDescription.value), 1)
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "rounded-lg p-1 text-eblack-500 hover:bg-ewhite-100",
                                    "aria-label": _unref(t)('settings.billing.payments.actions.close'),
                                    onClick: closeAction
                                }, [
                                    _createVNode(_unref(IconX), { class: "h-5 w-5" })
                                ], 8, _hoisted_61)
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                                (actionModal.value.type === 'refund')
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_63, [
                                        _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.fields.amount_minor")) + " ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((actionForm.amount_minor) = $event)),
                                            min: "1",
                                            type: "number",
                                            class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                            "data-test": "payments-action-amount"
                                        }, null, 512), [
                                            [
                                                _vModelText,
                                                actionForm.amount_minor,
                                                void 0,
                                                { number: true }
                                            ]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (actionModal.value.type === 'refund')
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_64, [
                                        _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.fields.currency")) + " ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((actionForm.currency) = $event)),
                                            maxlength: "3",
                                            class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm uppercase"
                                        }, null, 512), [
                                            [
                                                _vModelText,
                                                actionForm.currency,
                                                void 0,
                                                { trim: true }
                                            ]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (actionModal.value.type === 'payout_status')
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_65, [
                                        _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.fields.status")) + " ", 1),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((actionForm.status) = $event)),
                                            class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                        }, [
                                            _createElementVNode("option", _hoisted_66, _toDisplayString(statusLabel("submitted")), 1),
                                            _createElementVNode("option", _hoisted_67, _toDisplayString(statusLabel("paid")), 1),
                                            _createElementVNode("option", _hoisted_68, _toDisplayString(statusLabel("failed")), 1),
                                            _createElementVNode("option", _hoisted_69, _toDisplayString(statusLabel("cancelled")), 1)
                                        ], 512), [
                                            [_vModelSelect, actionForm.status]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (actionModal.value.type === 'reconciliation')
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_70, [
                                        _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.fields.status")) + " ", 1),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((actionForm.status) = $event)),
                                            class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                        }, [
                                            _createElementVNode("option", _hoisted_71, _toDisplayString(statusLabel("matched")), 1),
                                            _createElementVNode("option", _hoisted_72, _toDisplayString(statusLabel("ignored")), 1)
                                        ], 512), [
                                            [_vModelSelect, actionForm.status]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("label", _hoisted_73, [
                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.fields.reason")) + " ", 1),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((actionForm.reason) = $event)),
                                        rows: "3",
                                        class: "rounded-md border border-ewhite-200 px-3 py-2 text-sm",
                                        "data-test": "payments-action-reason",
                                        placeholder: _unref(t)('settings.billing.payments.fields.reason_placeholder')
                                    }, null, 8, _hoisted_74), [
                                        [
                                            _vModelText,
                                            actionForm.reason,
                                            void 0,
                                            { trim: true }
                                        ]
                                    ])
                                ]),
                                _createElementVNode("label", _hoisted_75, [
                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.fields.evidence_url")) + " ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((actionForm.evidence_url) = $event)),
                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                        "data-test": "payments-action-evidence",
                                        placeholder: _unref(t)('settings.billing.payments.fields.evidence_placeholder')
                                    }, null, 8, _hoisted_76), [
                                        [
                                            _vModelText,
                                            actionForm.evidence_url,
                                            void 0,
                                            { trim: true }
                                        ]
                                    ])
                                ]),
                                (['refund', 'payout_create'].includes(actionModal.value.type))
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_77, [
                                        _createTextVNode(_toDisplayString(_unref(t)("settings.billing.payments.fields.idempotency_key")) + " ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((actionForm.idempotency_key) = $event)),
                                            class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                            "data-test": "payments-action-idempotency"
                                        }, null, 512), [
                                            [
                                                _vModelText,
                                                actionForm.idempotency_key,
                                                void 0,
                                                { trim: true }
                                            ]
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-semibold text-eblack-700 hover:bg-ewhite-50",
                                    onClick: closeAction
                                }, _toDisplayString(_unref(t)("settings.billing.payments.actions.cancel")), 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "h-9 rounded-lg bg-eblack-900 px-3 text-sm font-semibold text-white hover:bg-eblack-800 disabled:opacity-50",
                                    disabled: !canSubmitAction.value || _unref(store).isSaving,
                                    "data-test": "payments-action-confirm",
                                    onClick: submitAction
                                }, _toDisplayString(_unref(t)("settings.billing.payments.actions.confirm")), 9, _hoisted_79)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
